import React, { useState } from 'react';
import styles from './firstScreen.module.css';
import romiImg from '../../images/romi-hero2.webp';
import maximovaLogo from '../../images/maximova-logo.webp';
import proof1 from '../../images/students_certificate_1.webp';
import proof2 from '../../images/students_certificate_2.webp';
import proof3 from '../../images/students_certificate_3.webp';
import proof4 from '../../images/students_certificate_4.webp';
import proof5 from '../../images/students_certificate_5.webp';
import proof6 from '../../images/students_certificate_6.webp';
import proof7 from '../../images/students_certificate_7.webp';
import proof8 from '../../images/students_certificate_8.webp';
import proof9 from '../../images/students_certificate_9.webp';
import proof10 from '../../images/students_certificate_10.webp';
import FormModal from '../../components/formModal/FormModal';

function FirstScreen() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <>
      <section className={styles.hero} id="hero">
        {/* Ambient glows */}
        <div className={styles.glowTopRight} />
        <div className={styles.glowBottomLeft} />
        <div className={styles.glowBottomCenter} />
        <div className={styles.glowLeft} />

        {/* Floating sparkles */}
        <div className={`${styles.sparkle} ${styles.sparkle1}`} />
        <div className={`${styles.sparkle} ${styles.sparkle2}`} />
        <div className={`${styles.sparkle} ${styles.sparkle3}`} />
        <div className={`${styles.sparkle} ${styles.sparkle4}`} />
        <div className={`${styles.sparkle} ${styles.sparkle5}`} />
        <div className={`${styles.sparkle} ${styles.sparkle6}`} />
        <div className={`${styles.sparkle} ${styles.sparkle7}`} />
        <div className={`${styles.sparkle} ${styles.sparkle8}`} />
        <div className={`${styles.sparkle} ${styles.sparkle9}`} />
        <div className={`${styles.sparkle} ${styles.sparkle10}`} />
        <div className={`${styles.sparkle} ${styles.sparkle11}`} />
        <div className={`${styles.sparkle} ${styles.sparkle12}`} />
        <div className={`${styles.sparkle} ${styles.sparkle13}`} />
        <div className={`${styles.sparkle} ${styles.sparkle14}`} />
        <div className={`${styles.sparkle} ${styles.sparkle15}`} />
        <div className={`${styles.sparkle} ${styles.sparkle16}`} />
        <div className={`${styles.sparkle} ${styles.sparkle17}`} />
        <div className={`${styles.sparkle} ${styles.sparkle18}`} />
        <div className={`${styles.sparkle} ${styles.sparkle19}`} />
        <div className={`${styles.sparkle} ${styles.sparkle20}`} />
        <div className={`${styles.sparkle} ${styles.sparkle21}`} />
        <div className={`${styles.sparkle} ${styles.sparkle22}`} />
        <div className={`${styles.sparkle} ${styles.sparkle23}`} />
        <div className={`${styles.sparkle} ${styles.sparkle24}`} />
        <div className={`${styles.sparkle} ${styles.sparkle25}`} />
        <div className={`${styles.sparkle} ${styles.sparkle26}`} />
        <div className={`${styles.sparkle} ${styles.sparkle27}`} />
        <div className={`${styles.sparkle} ${styles.sparkle28}`} />
        <div className={`${styles.sparkle} ${styles.sparkle29}`} />
        <div className={`${styles.sparkle} ${styles.sparkle30}`} />

        {/* Decorative arcs */}
        <div className={styles.arcLeft} />
        <div className={styles.arcRight} />

        {/* ── Intro Banner ── */}
        <div className={`${styles.introBanner} ${styles.enterIntro}`}>
          <div className={styles.introBannerInner}>
            <p className={styles.introBannerText}>
              המדריכה הרשמית של <img src={maximovaLogo} alt="Maximova" className={styles.introBannerLogo} /> בישראל
            </p>
            <p className={styles.introBannerText}>המאסטרית רומי פרץ מציגה:</p>
          </div>
        </div>

        <div className={styles.container}>

          {/* ── Text Section ── */}
          <div className={`${styles.textSection} ${styles.enterText}`}>
            <h1 className={styles.heroH1}>
              הדרך להפוך את התשוקה שלך
              <br />
              <span className={styles.heroH1Underline}>לקריירה רווחית עם החופש</span>
              <br />
              <span className={styles.heroH1Underline}>שתמיד חלמת עליו</span>
            </h1>
            <p className={styles.heroObjestion}>
              (גם אם יש לך אפס ניסיון בתחום וגם אם את בטוחה שיש לך ״שתי ידיים שמאליות״)
            </p>
          </div>

          {/* ── Image + CTA Section ── */}
          <div className={styles.visualSection}>
            <div className={`${styles.imgArea} ${styles.enterImg}`}>
              <div className={styles.imgGlowOuter} />
              <div className={styles.imgGlowInner} />

              {/* Diagonal ribbon BEHIND Romi */}
              <div className={styles.ribbonWrap}>
                <div className={styles.ribbonTrack}>
                  {[0, 1].map((i) => (
                    <div className={styles.ribbonSlide} key={i} aria-hidden={i > 0}>
                      {[...Array(8)].map((_, j) => (
                        <React.Fragment key={j}>
                          <span className={styles.ribbonText}>מדריכה בינלאומית מטעם</span>
                          <img src={maximovaLogo} alt={j === 0 && i === 0 ? 'Maximova' : ''} className={styles.ribbonLogo} />
                          <span className={styles.ribbonDot}>✦</span>
                        </React.Fragment>
                      ))}
                    </div>
                  ))}
                </div>
              </div>

              <img src={romiImg} alt="רומי פרץ" className={styles.heroImg} />
            </div>

          </div>

        </div>

        {/* ── CTA Banner (from bottom) ── */}
        <div className={`${styles.ctaArea} ${styles.enterCta}`}>
          <div className={styles.ctaAreaInner}>
            <button
              className={styles.ctaBtn}
              onClick={() => setIsFormOpen(true)}
            >
              <span className={styles.ctaShine} />
              <div className={styles.ctaContent}>
                <div className={styles.proofAvatars}>
                  {[proof1, proof2, proof3, proof4, proof5, proof6, proof7, proof8, proof9, proof10].map((src, i) => (
                    <img key={i} src={src} alt="" className={styles.proofAvatar} />
                  ))}
                </div>
                <span className={styles.ctaText}>
                  לחצי כאן והצטרפי לעוד עשרות נשים שהפכו לבוס של עצמן
                </span>
              </div>
            </button>
          </div>
        </div>
      </section>

      <FormModal isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </>
  );
}

export default FirstScreen;